<template>
	<Page :info="info"/>
</template>
<script>
import Page from '../common/Page'
export default {
	components:{Page},
	data(){
		return {
			info:{
				banner:{
					img:'/static/images/scheme/banner8.jpg',
					title:'建筑行业风险解决方案',
					subtitle:'我们针对于建筑行业特性，输出定制如下组合方案， <br>供建筑行业基于企业需求进行投保'
				},
				product:[9,10,7,11,12,5],
				case:[8,9]
			}
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/pages/scheme/components/page/Jianzhu.vue